import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Setting from './Setting';
import ButtonAction from './ButtonAction';
import { conversionOutput, getFileTypeName } from '../helpers/FileHelpers';

export default class SettingsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      settingStates: this.initialSettingValues(),
    };
  }

  getSettings() {
    return this.props.settings || [];
  }

  initialSettingValues = () => {
    const vals = {};
    this.getSettings().map(setting =>
      vals[setting.slug] = setting.enabled,
    );
    return vals;
  }

  stillInitialValues = () => JSON.stringify(this.state.settingStates) === JSON.stringify(this.initialSettingValues())

  saveSettings = () => {
    if (!!this.props.updateSettings && !this.stillInitialValues()) {
      this.props.updateSettings(this.state.settingStates);
    }
    this.props.closeModal();
  }

  updateSetting = (slug, val) => {
    const currentSettings = this.state.settingStates;
    currentSettings[slug] = val;
    this.setState({ settingStates: currentSettings });
  }

  render() {
    return (<Modal
      isOpen={this.props.modalOpen}
      toggle={this.props.closeModal}
      ref="BSModal"
    >
      <ModalHeader>
          {getFileTypeName(this.props.input)} to {conversionOutput(this.props.input, this.props.output)} Settings
      </ModalHeader>
      <ModalBody>
        <ul className="list-group">
          {this.getSettings().map(setting =>
            (<Setting
              name={setting.name}
              description={setting.description}
              slug={setting.slug}
              key={setting.slug}
              enabled={setting.enabled}
              scrDefault={setting.scrDefault}
              orgDefault={setting.hasOwnProperty('orgDefault') ? setting.orgDefault : null}
              notify={this.updateSetting}
            />),
          )}
        </ul>
      </ModalBody>
      <ModalFooter>
        <ButtonAction
          action={this.saveSettings}
          color="success"
        >
          Save
        </ButtonAction>
        <Button
          color="info"
          onClick={this.props.closeModal}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>);
  }

}
